import { JSX, useState, useEffect } from 'react';
import { parseQuery } from '@betgames/bg-tools';
import { useLocation, Navigate, Route, Routes } from 'react-router-dom';
import { InitialPageSkeleton } from '@bg-components/Skeleton';
import { IAuthUrlParams, authService, routeUrlGenerator } from '@bg-shared';

export const Auth = (): JSX.Element => {
    const location = useLocation();
    const params = parseQuery<IAuthUrlParams>(location.search);
    const [pending, setPending] = useState<boolean>(true);

    useEffect(() => {
        authService.authorise(location.search).then(() => {
            setPending(false);
        });
    }, []);

    const gameId =
        Number(params.singleGame || params.gameId || params.defaultGame) ||
        routeUrlGenerator.lobbyGameId;

    const defaultPage = params.pageName || params.defaultPage;

    if (pending) {
        return <InitialPageSkeleton />;
    }

    return (
        <Routes>
            {!!params.redirect && (
                <Route path="*" element={<Navigate replace to={params.redirect} />} />
            )}
            {!!defaultPage && (
                <Route
                    path="*"
                    element={
                        <Navigate
                            replace
                            to={routeUrlGenerator.getAuthRedirectUrl(defaultPage, {
                                gameId,
                                runId: params.runId,
                            })}
                        />
                    }
                />
            )}
            {!params.redirect && !defaultPage && (
                <Route
                    path="*"
                    element={<Navigate replace to={routeUrlGenerator.getGameUrl(gameId)} />}
                />
            )}
        </Routes>
    );
};
